import { UpdateReadStatusRequestDto } from '@asset-metrix/portal-gateway-client-js';

import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const datatableMarkAsRead = async ({
  widgetId,
  data,
}: {
  widgetId: string;
  data: UpdateReadStatusRequestDto;
}) => {
  const res = await portalGatewayClient.table.updateDocumentReadStatus(
    widgetId,
    data
  );

  if (res.ok) {
    return res.data;
  }

  throw new HttpError('Error marking documents as read', res);
};
